import organization from './config-organization';
import position from './config-position';
import WizTableForm from "../wizTableForm";

let organizationConfig = organization(this, { apiParams: { state: 1} });
let positionConfig = position(this, { apiParams: { state: 1 } });

const columns = ({ isShowOrganizationSearch = true }) => {
  let columns_ = [];
  columns_ = columns_.concat([
    {
      title: '账号',
      name: 'searchUserName',
      dataIndex: 'searchUserName',
      searchItem: {}
    },
    {
      title: '账号',
      name: 'userName',
      dataIndex: 'userName',
      tableItem: {
        width: 150
      }
    },
    {
      title: '姓名',
      name: 'searchFullName',
      dataIndex: 'searchFullName',
      searchItem: {}
    },
    {
      title: '姓名',
      name: 'fullName',
      dataIndex: 'fullName',
      tableItem: {
        width: 120
      }
    },
    {
      title: '身份证号/工号',
      name: 'idCard',
      dataIndex: 'idCard',
      tableItem: {
        width: 180
      }
    }]);
  if (isShowOrganizationSearch){
    columns_ = columns_.concat([
      {
        title: '组织名称',
        name: 'orgId',
        dataIndex: 'orgId',
        searchItem: {
          ...organizationConfig,
          diy: WizTableForm,
          selectType: 'radio',
          initialValue: undefined,
        }
      }
    ])
  }
  columns_ = columns_.concat([
    {
      title: '岗位名称',
      name: 'positionIds',
      dataIndex: 'positionIds',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm
      }
    },
    {
      title: '手机号',
      name: 'mobile',
      dataIndex: 'mobile',
      tableItem: {
        width: 150
      }
    },
    {
      title: '组织名称',
      name: 'orgName',
      dataIndex: 'orgName',
      tableItem: {
        width: 150
      }
    },
    {
      title: '组织编码',
      name: 'orgCode',
      dataIndex: 'orgCode',
      tableItem: {
        width: 160
      }
    },
    {
      title: '岗位名称',
      name: 'positionName',
      dataIndex: 'positionName',
      tableItem: {
        width: 150
      }
    }
  ])
  return columns_
};

const tableApi = (api = {}) => {
  return {
    path: 'userIdentityManagement/getUserIdentityDetailPage',
    ...api
  }
};

const userIdentity = (self, api) => {
  if (api?.apiParams?.isNotAuth) {
    organizationConfig = organization(this, { apiParams: { state: 1, isNotAuth: true} });
    positionConfig = position(this, { apiParams: { state: 1, isNotAuth: true} });
  }
  let isShowOrganizationSearch = true;
  if (api?.apiParams?.isNotShowOrganization){
    isShowOrganizationSearch = false;
  }
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'personId',
    rowTitle: 'userName',
    rowName: 'fullName',
    columns: columns({ isShowOrganizationSearch }),
    tableApi: tableApi(api)
  }
};

export default userIdentity
